"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _asicsSpiralLogoBlue = _interopRequireDefault(require("../../images/asics-spiral-logo-blue.svg"));

var _stitches = require("../../stitches.config");

var _themeMap = _interopRequireDefault(require("../../themes/themeMap"));

var LogoWrapper = (0, _stitches.styled)('div', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '40px',
  width: '100%',
  '@tablet': {
    flex: {
      display: 'flex'
    },
    none: {
      display: 'none'
    }
  }
});
var BrandLogoImage = (0, _stitches.styled)('img', {
  width: '23%',
  variants: {
    style: {
      asics_studio: {
        width: '45%',
        padding: '3% 0'
      },
      onitsuka_tiger_ana: {
        width: '33%'
      },
      onitsuka_tiger_au: {
        width: '33%'
      },
      onitsuka_tiger_kr: {
        width: '33%'
      },
      runkeeper: {
        width: '50%',
        padding: '5% 0'
      }
    }
  }
});
var LogoText = (0, _stitches.styled)('div', {
  fontSize: '$small',
  fontWeight: '$medium'
});
/**
 * The logo of the brand with optional sub text.
 */

var BrandLogo = function BrandLogo(_ref) {
  var _themeMap$style;

  var style = _ref.style,
      text = _ref.text;
  var image = style ? ((_themeMap$style = _themeMap.default[style]) === null || _themeMap$style === void 0 ? void 0 : _themeMap$style.images.brandLogo) || _asicsSpiralLogoBlue.default : _asicsSpiralLogoBlue.default;
  var showMobile = !style.includes('onitsuka_tiger');
  return /*#__PURE__*/_react.default.createElement(LogoWrapper, {
    display: {
      '@initial': showMobile ? 'flex' : 'none',
      '@desktop': 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement(BrandLogoImage, {
    alt: "Asics Logo",
    src: image,
    style: style
  }), /*#__PURE__*/_react.default.createElement(LogoText, null, text));
};

BrandLogo.defaultProps = {
  style: '',
  text: ''
};
var _default = BrandLogo;
exports.default = _default;